import { utils, writeFile } from 'xlsx';


const dataToSheet = (dataSource, columns) => {
  const header = [];
  const headerMap = {};
  (columns || []).forEach((column) => {
    header.push(column.title);
    if (!headerMap[column.dataIndex]) {
      headerMap[column.dataIndex] = column.title;
    }
  });
  const results = (dataSource || []).map((data) => {
    const item = {};
    for (const key in headerMap) {
      item[headerMap[key]] = data[key];
    }
    return item;
  });
  return utils.json_to_sheet(results, { header });  
}

export const exportFile = (dataSource, columns, fileName) => {
  const wb = utils.book_new();
  const sheet = dataToSheet(dataSource, columns);
  utils.book_append_sheet(wb, sheet);
  writeFile(wb, fileName || '导出文件.xlsx');
};
